import * as React from 'react';
import { Spinner } from '@cian/ui-kit';

import * as styles from './SeoMarkedListPlaceholder.css';

const PADDING_HEIGHT = 16;
const HEADING_HEIGHT = 28;
const HEADING_GAP = 24;
const ITEM_HEIGHT = 57;

interface ISeoMarkedListPlaceholderProps {
  itemsCount: number;
}

export const SeoMarkedListPlaceholder = ({ itemsCount }: ISeoMarkedListPlaceholderProps) => {
  const height = PADDING_HEIGHT + HEADING_HEIGHT + HEADING_GAP + itemsCount * ITEM_HEIGHT;

  const style = React.useMemo(() => ({ height: `${height}px` }), [height]);

  return (
    <div className={styles['container']} style={style} data-testid="SeoMarkedListPlaceholder">
      <Spinner size={40} />
    </div>
  );
};
